import { render, staticRenderFns } from "./PlaylistCarousel.vue?vue&type=template&id=3571f892&scoped=true&"
import script from "./PlaylistCarousel.vue?vue&type=script&lang=js&"
export * from "./PlaylistCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistCarousel.vue?vue&type=style&index=0&id=3571f892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3571f892",
  null
  
)

/* custom blocks */
import block0 from "./PlaylistCarousel.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports